import BaseAPI from "./BaseAPI";

/**
 * Portal API
 * @extends BaseAPI
 */
export default class PortalAPI extends BaseAPI {
  /**
   * Get portals for current organization
   *
   * @returns {Promise<Object[]>} Portal
   */
  static all() {
    return this.execute("get", "/v1/portals");
  }

  /**
   * Get a portal
   *
   * @param {String} id Portal id
   * @returns {Promise<Object>} Portal
   */
  static get(id) {
    return this.execute("get", `/v1/portals/${id}`);
  }

  /**
   * Check portal name availability
   *
   * @param {string} name Portal name
   * @returns {Promise<boolean>} Availability
   */
  static checkAvailability(name) {
    return this.execute("get", `/v1/portals/availability?name=${name}`);
  }

  /**
   * Update a portal
   *
   * @param {string} id Portal id
   * @param {Object} portal Portal update
   * @returns {Promise<Object>} Updated portal
   */
  static update(id, portal) {
    return this.execute("patch", `/v1/portals/${id}`, portal);
  }

  /**
   * Delete a portal
   *
   * @param {string} id Portal id
   * @returns {Promise<Object>}
   */
  static delete(id) {
    return this.execute("delete", `/v1/portals/${id}`);
  }
}
